/* eslint-disable react-hooks/exhaustive-deps */

import { FormEvent, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { StatusCode } from '../../api/enumerations';
import { recoverPasswordEmail } from '../../api/resetPassword';
import { EmailIcon } from '../../components/InputIcon';
import Snackbar from '../../components/Snackbar';
import { Constants } from '../../constants/forgotPassword';
import { GlobalContext } from '../../context/global';
import { validateEmail } from '../../helpers';
import { getLocalStorageToken } from '../../helpers/localStorage';
import useErrorMessage from '../../hooks/useErrorMessage';
import useSnackbar from '../../hooks/useSnackbar';
import {
  CancelButton,
  ContainerGrid,
  FlexBox,
  InputBox,
  InputTitle,
  LoginGrid,
  LogoGrid,
  LogoImg,
  SmallSubmitButton,
  StyledTextField,
} from './styles';

export function ForgotPassword({ logo }: { logo: string }): JSX.Element {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);

  const { getErrorMessage } = useErrorMessage();
  const { handleSnackbar } = useSnackbar();
  const { openSnackbar } = useContext(GlobalContext);

  const navigate = useNavigate();
  const token = getLocalStorageToken();

  useEffect(() => {
    if (token !== null && token !== 'undefined') {
      navigate('/home');
    }
  }, [navigate, token]);

  const handleSendEmail = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    const trimEmail = email.trim();

    try {
      const response = await recoverPasswordEmail(trimEmail);

      if (response.detail.status_code === StatusCode.NOT_FOUND) {
        handleSnackbar('Um link foi enviado para seu email.', false);
        navigate('/login');
        return;
      }

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (response.detail.status_code !== StatusCode.OK)
        throw new Error('Algo deu errado, tente novamente.');

      handleSnackbar('Um link foi enviado para seu email.', false);
      navigate('/login');
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
      navigate('/login');
    }
  };

  return (
    <ContainerGrid container>
      <LogoGrid item xs={8}>
        <LogoImg>
          <img src={logo} alt="Logo" />
        </LogoImg>
      </LogoGrid>
      <LoginGrid item xs={4}>
        <InputBox component="form" id="recover" onSubmit={handleSendEmail}>
          <InputTitle>{Constants.recoverPassword}</InputTitle>
          <StyledTextField
            required
            id="email"
            variant="standard"
            InputProps={EmailIcon}
            placeholder={Constants.emailPlaceholder}
            error={emailError}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              !validateEmail(e.target.value)
                ? setEmailError(true)
                : setEmailError(false);
            }}
          />
          <FlexBox>
            <CancelButton onClick={() => navigate('/login')}>
              {Constants.cancel}
            </CancelButton>
            <SmallSubmitButton
              form="recover"
              type="submit"
              disabled={emailError}
            >
              {Constants.submit}
            </SmallSubmitButton>
          </FlexBox>
        </InputBox>
      </LoginGrid>
      {openSnackbar && <Snackbar />}
    </ContainerGrid>
  );
}
